import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import { Form, Col, Row } from "react-bootstrap";
import { TrashIcon } from "../../../resources/media/TrashIcon";
import { PlusIcon } from '../../../resources/media/PlusIcon';
import { COUNTRIES, US_STATE_OPTIONS, PARTY_TYPES } from "../../../resources/constants/dropdowns";
import { REMOVE_BUTTON_LABEL, ADD_EMAIL_BUTTON_LABEL } from "../../../resources/constants/ui";
import { 
	PARTY_LABEL, 
	FILED_FOR_FIELD, 
	FILED_FOR_LABEL, 
	FILED_BY_FIELD, 
	FILED_BY_LABEL, 
	FILED_BY_LABEL_END, 
	COMPANY_FIELD, 
	COMPANY_LABEL, 
	ADDRESS_ONE_FIELD, 
	ADDRESS_ONE_LABEL, 
	ADDRESS_TWO_LABEL, 
	ADDRESS_TWO_FIELD, 
	CITY_FIELD, 
	CITY_LABEL, 
	STATE_FIELD, 
	STATE_LABEL, 
	ZIP_FIELD, 
	ZIP_LABEL, 
	COUNTRY_LABEL, 
	COUNTRY_FIELD, 
	PHONE_FIELD, 
	PHONE_LABEL, 
	FAX_LABEL, 
	FAX_FIELD, 
	EMAIL_FIELD, 
	EMAILS_LABEL, 
	ADDITIONAL_EMAIL_LABEL, 
	ADDITIONAL_EMAIL_FIELD, 
	EMAILS_TEXT, 
	FORMAL_FILING_FORM_TYPE, 
	RECORDATION_FORM_TYPE, 
	OTHER_FILING_FORM_TYPE, 
	COMPANY_NAME_LABEL, 
	PARTY_TYPE_FIELD, 
	PARTY_TYPE_LABEL, 
	OTHER_PARTY_TYPE_FIELD, 
	OTHER_PARTY_TYPE_LABEL 
} from "../../../resources/constants/fields";
import { FormParagraph, FieldWithLabel, CustomFormRow, RequiredSymbol, SelectOptions } from "./common";
import { getFieldError } from "../util/validation";
import { MARGIN, LABEL_SIZE, INPUT_SIZE } from "../../../resources/constants/dimensions";
import { REQUIRED_ERROR, MAX_EMAILS_ERROR } from "../../../resources/constants/errors";
import { PARTY_LIMITS } from "../../../resources/constants/validations";

class FilingParty extends Component {
	constructor(props) {
		super(props);
		this.state = {
			filedFor: "",
			filedBy: "",
			partyType: "",
			otherPartyType: "",
			company: "",
			address1: "",
			address2: "",
			city: "",
			state: "",
			zip: "",
			country: COUNTRIES[0],
			phone: "",
			fax: "",
			email: "",
			additionalEmails: [],
			errors: []
		};
	}

	render() {
		let total = this.props.total;
		let idx = this.props.index;
		let partyLabel = PARTY_LABEL;
		let button = null;
		if (total > PARTY_LIMITS[this.props.type].min) {
			button = (
				<Button
					variant={"danger"}
					onClick={() => this.props.remove(idx)}
					className={"float-right"}
				>
					{REMOVE_BUTTON_LABEL}
				</Button>
			);
		}
		return (
			<div key={`${PARTY_LABEL}-${idx}`} className={"panel"}>
				<FormParagraph className="party-title gray-text">
					<h5
						className={"party-title__text inline-block"}
					>{`(${partyLabel} ${idx + 1}/${total})`}</h5>
					{button}
				</FormParagraph>

				{getPartyFields(this.props)}
			</div>
		);
	}
}

const getPartyFields = props => {
	switch(props.type){
		case FORMAL_FILING_FORM_TYPE:
		case OTHER_FILING_FORM_TYPE:
			return (
				<>
					<FiledFor {...props}/>
					<FiledBy {...props}/>
					<Company {...props}/>
					<AddressOne {...props}/>
					<AddressTwo {...props}/>
					<City {...props}/>
					<State {...props}/>
					<Zip {...props}/>
					<Country {...props}/>
					<Phone {...props}/>
					<Fax {...props}/>
					<Email {...props}/>
					<AdditionalEmails {...props}/>
				</>
			);
		case RECORDATION_FORM_TYPE:
			return (
				<>
					<PartyType {...props}/>
					<Other {...props}/>
					<CompanyName {...props}/>
					<AddressOne {...props}/>
					<AddressTwo {...props}/>
					<City {...props}/>
					<State {...props}/>
					<Zip {...props}/>
					<Country {...props}/>
				</>
			);
		default:
			return <></>;
	}
};


 const FiledFor = props => (
	<FieldWithLabel
		id={`${FILED_FOR_FIELD}-${props.index}`}
		name={FILED_FOR_FIELD}
		className={"filed-for-field"}
		labelText={<strong>{FILED_FOR_LABEL}</strong>}
		handleBlur={props.handleBlur}
		handleChange={props.handleChange}
		value={props.party.state[FILED_FOR_FIELD]}
		isInvalid={
			props.errors.filter(
				error =>
					error.fieldId === `${FILED_FOR_FIELD}-${props.index}`
			).length > 0
		}
		invalid={getFieldError(props.errors, FILED_FOR_FIELD, props.index)}
	/>
 );

 const FiledBy = props => (
	<FieldWithLabel
		id={`${FILED_BY_FIELD}-${props.index}`}
		name={FILED_BY_FIELD}
		labelText={<strong>{FILED_BY_LABEL}</strong>}
		placeholder={FILED_BY_LABEL_END}
		handleBlur={props.handleBlur}
		handleChange={props.handleChange}
		value={props.party.state[FILED_BY_FIELD]}
		isInvalid={
			props.errors.filter(
				error =>
					error.fieldId === `${FILED_BY_FIELD}-${props.index}`
			).length > 0
		}
		invalid={getFieldError(props.errors, FILED_BY_FIELD, props.index)}
	/>
 );

const PartyType = props => (
	<CustomFormRow labelText={<span><RequiredSymbol />{PARTY_TYPE_LABEL}</span>}>
		<Form.Control
			required
			as="select"
			id={`${PARTY_TYPE_FIELD}-${props.index}`}
			name={PARTY_TYPE_FIELD}
			value={props.party.state[PARTY_TYPE_FIELD]}
			onBlur={props.handleBlur}
			onChange={props.handleChange}
			isInvalid={
				props.errors.filter(
					error =>
						error.fieldId === `${PARTY_TYPE_FIELD}-${props.index}`
				).length > 0
			}
			invalid={getFieldError(props.errors, PARTY_TYPE_FIELD, props.index)}
		>
			<option value="" style={{"display":"none"}}></option>
			{PARTY_TYPES.map((type, index) => {
				return ( 
					<option key={`${type}-${index}`} value={type}>
						{type}
					</option>
				)
			})}
		</Form.Control>
	</CustomFormRow>
);

const Other = props => {
	if(props.party.state.partyType === PARTY_TYPES[PARTY_TYPES.length - 1]){
		return <FieldWithLabel
			id={`${OTHER_PARTY_TYPE_FIELD}-${props.index}`}
			name={OTHER_PARTY_TYPE_FIELD}
			labelText={OTHER_PARTY_TYPE_LABEL}
			handleBlur={props.handleBlur}
			handleChange={props.handleChange}
			value={props.party.state[OTHER_PARTY_TYPE_FIELD]}
			isInvalid={
				props.errors.filter(
					error => error.fieldId === `${OTHER_PARTY_TYPE_FIELD}-${props.index}`
				).length > 0
			}
			invalid={getFieldError(props.errors, OTHER_PARTY_TYPE_FIELD, props.index)}
		/>;
	} else {
		return <></>;
	}
};

 const Company = props => (
	 <FieldWithLabel
		id={`${COMPANY_FIELD}-${props.index}`}
		name={COMPANY_FIELD}
		labelText={COMPANY_LABEL}
		handleBlur={props.handleBlur}
		handleChange={props.handleChange}
		value={props.party.state[COMPANY_FIELD]}
		isInvalid={
			props.errors.filter(
				error => error.fieldId === `${COMPANY_FIELD}-${props.index}`
			).length > 0
		}
		invalid={getFieldError(props.errors, COMPANY_FIELD, props.index)}
	/>
 );

 const CompanyName = props => (
	<FieldWithLabel
	   id={`${COMPANY_FIELD}-${props.index}`}
	   name={COMPANY_FIELD}
	   labelText={COMPANY_NAME_LABEL}
	   handleBlur={props.handleBlur}
	   handleChange={props.handleChange}
	   value={props.party.state[COMPANY_FIELD]}
	   isInvalid={
		   props.errors.filter(
			   error => error.fieldId === `${COMPANY_FIELD}-${props.index}`
		   ).length > 0
	   }
	   invalid={getFieldError(props.errors, COMPANY_FIELD, props.index)}
   />
);
 
 const AddressOne = props => (
	<FieldWithLabel
		id={`${ADDRESS_ONE_FIELD}-${props.index}`}
		name={ADDRESS_ONE_FIELD}
		labelText={ADDRESS_ONE_LABEL}
		handleBlur={props.handleBlur}
		handleChange={props.handleChange}
		value={props.party.state[ADDRESS_ONE_FIELD]}
		isInvalid={
			props.errors.filter(
				error =>
					error.fieldId === `${ADDRESS_ONE_FIELD}-${props.index}`
			).length > 0
		}
		invalid={getFieldError(props.errors, ADDRESS_ONE_FIELD, props.index)}
	/>
 );

 const AddressTwo = props => (
	<Form.Row>
		<Col lg={MARGIN || 1} />
		<Form.Group
			as={Col}
			lg={12 - (MARGIN || 1) - (MARGIN || 1)}
		>
			<Row>
				<Col md={LABEL_SIZE || 4}>
					<Form.Label>{ADDRESS_TWO_LABEL}</Form.Label>
				</Col>
				<Col md={INPUT_SIZE || 8}>
					<Form.Control
						id={`${ADDRESS_TWO_FIELD}-${props.index}`}
						type="text"
						name={ADDRESS_TWO_FIELD}
						value={props.party.state[ADDRESS_TWO_FIELD]}
						onBlur={props.handleBlur}
						onChange={props.handleChange}
					/>
				</Col>
			</Row>
		</Form.Group>
		<Col lg={MARGIN || 1} />
	</Form.Row>
 );

const City = props => (
	<FieldWithLabel
		id={`${CITY_FIELD}-${props.index}`}
		name={CITY_FIELD}
		labelText={CITY_LABEL}
		handleBlur={props.handleBlur}
		handleChange={props.handleChange}
		value={props.party.state[CITY_FIELD]}
		isInvalid={
			props.errors.filter(
				error => error.fieldId === `${CITY_FIELD}-${props.index}`
			).length > 0
		}
		invalid={getFieldError(props.errors, CITY_FIELD, props.index)}
	/>
);

const State = props => (
	props.party.state.country === COUNTRIES[0] ?
		<CustomFormRow labelText={<span><RequiredSymbol />{STATE_LABEL}</span>}>
			<Form.Control
				required
				as="select"
				id={`${STATE_FIELD}-${props.index}`}
				name={STATE_FIELD}
				value={props.party.state[STATE_FIELD]}
				onBlur={props.handleBlur}
				onChange={props.handleChange}
				isInvalid={
					props.errors.filter(
						error =>
							error.fieldId === `${STATE_FIELD}-${props.index}`
					).length > 0
				}
				invalid={getFieldError(props.errors, STATE_FIELD, props.index)}
			>
				<option value="" style={{"display":"none"}}></option>
				{US_STATE_OPTIONS.map((state, index) => {
					return (
						<option key={`${state.name}-${index}`} value={state.abbrv}>
							{`${state.abbrv} - ${state.name}`}
						</option>
					)
				})}
			</Form.Control>
		</CustomFormRow>
	:	
		<FieldWithLabel
			id={`${STATE_FIELD}-${props.index}`}
			name={STATE_FIELD}
			labelText={STATE_LABEL}
			handleBlur={props.handleBlur}
			handleChange={props.handleChange}
			value={props.party.state[STATE_FIELD]}
			isInvalid={
				props.errors.filter(
					error => error.fieldId === `${STATE_FIELD}-${props.index}`
				).length > 0
			}
			invalid={getFieldError(props.errors, STATE_FIELD, props.index)}
		/> 
);

const Zip = props => (
	<FieldWithLabel
		id={`${ZIP_FIELD}-${props.index}`}
		name={ZIP_FIELD}
		labelText={ZIP_LABEL}
		handleBlur={props.handleBlur}
		handleChange={props.handleChange}
		value={props.party.state[ZIP_FIELD]}
		isInvalid={
			props.errors.filter(
				error => error.fieldId === `${ZIP_FIELD}-${props.index}`
			).length > 0
		}
		invalid={getFieldError(props.errors, ZIP_FIELD, props.index)}
	/>
);

const Country = props => (
	<CustomFormRow labelText={<span><RequiredSymbol />{COUNTRY_LABEL}</span>}>
		<Form.Control
			required
			as="select"
			name={COUNTRY_FIELD}
			id={`${COUNTRY_FIELD}-${props.index}`}
			value={props.party.state[COUNTRY_FIELD]}
			onBlur={props.handleBlur}
			onChange={props.handleChange}
			isInvalid={
				props.errors.filter(
					error =>
						error.fieldId === `${COUNTRY_FIELD}-${props.index}`
				).length > 0
			}
			invalid={getFieldError(props.errors, COUNTRY_FIELD, props.index)}
		>
			<SelectOptions options={COUNTRIES} />
		</Form.Control>
	</CustomFormRow>
 );
const Phone = props => (
	<FieldWithLabel
		id={`${PHONE_FIELD}-${props.index}`}
		name={PHONE_FIELD}
		labelText={PHONE_LABEL}
		handleBlur={props.handleBlur}
		handleChange={props.handleChange}
		value={props.party.state[PHONE_FIELD]}
		isInvalid={
			props.errors.filter(
				error => error.fieldId === `${PHONE_FIELD}-${props.index}`
			).length > 0
		}
		invalid={getFieldError(props.errors, PHONE_FIELD, props.index)}
	/>
);
const Fax = props => (
	<FieldWithLabel
		optional={true}
		id={`${FAX_FIELD}-${props.index}`}
		name={FAX_FIELD}
		labelText={FAX_LABEL}
		handleBlur={props.handleBlur}
		handleChange={props.handleChange}
		value={props.party.state[FAX_FIELD]}
		isInvalid={
			props.errors.filter(
				error => error.fieldId === `${FAX_FIELD}-${props.index}`
			).length > 0
		}
		invalid={getFieldError(props.errors, FAX_FIELD, props.index)}
	/>
);
const Email = props => (
	<FieldWithLabel
		id={`${EMAIL_FIELD}-${props.index}`}
		name={EMAIL_FIELD}
		labelText={EMAILS_LABEL}
		handleBlur={props.handleBlur}
		handleChange={props.handleChange}
		value={props.party.state[EMAIL_FIELD]}
		isInvalid={
			props.errors.filter(
				error => error.fieldId === `${EMAIL_FIELD}-${props.index}`
			).length > 0
		}
		invalid={getFieldError(props.errors, EMAIL_FIELD, props.index)}
	/>
);
const AdditionalEmails = props => (
	<>
		<br/>
		<div className={"center addtional-email-label"}>{ADDITIONAL_EMAIL_LABEL}</div>
		
		{props.party.state.additionalEmails.length > 0 ? (
			<>
				{props.party.state[ADDITIONAL_EMAIL_FIELD].map(
					(additionalEmail, index) => {
						let additionalEmailId = `${ADDITIONAL_EMAIL_FIELD}-${props.index}-${index}`;
						let label = `${EMAILS_TEXT} ${index + 1}:`;
						
						return (
							<div key={additionalEmailId}>
								<CustomFormRow
									labelText={label}
								>
									<div className={"field-with-button"}>
										<Row>
											<Col className="additional-email-field">
												<Form.Control
													required
													id={additionalEmailId}
													type="text"
													name={additionalEmailId}
													value={additionalEmail}
													onBlur={props.handleBlur}
													onChange={props.handleChange}
													isInvalid={
														props.errors.filter(
															error =>
																error.fieldId ===
																additionalEmailId
														).length > 0
													}
												/>
												<Form.Control.Feedback type="invalid">
													{props.errors
														.filter(
															error =>
																(error.fieldId ===
																	additionalEmailId &&
																error.errorMsg !== REQUIRED_ERROR)
														)
														.reduce(
															(acc, cur) => [
																...acc,
																cur.errorMsg +
																	"\n"
															],
															[]
														)}
												</Form.Control.Feedback>
											</Col>
										</Row>
									</div>
									<Button
										className="field-btn remove-email__btn"
										variant="danger"
										onClick={() => {
											props.removeEmail(
												props.index,
												index
											);
										}}
									>
										<TrashIcon/>
									</Button>
								</CustomFormRow>
							</div>
						)
					}
				)}
			</>
		) : (
			<div />
		)}
		<div className={"center"}>
			<div
					key={`${ADDITIONAL_EMAIL_FIELD}-party${props.index}-add-email`}
				>

				{props.party.state[ADDITIONAL_EMAIL_FIELD].length < 10 ? (
					<Button
						variant="primary"
						onClick={() => props.addEmail(props.index)}
						className={"transparent-btn-primary"}
					>
						<PlusIcon/>
						<strong className="add-title">{ADD_EMAIL_BUTTON_LABEL}</strong>
					</Button>
				) : (
					<FormParagraph>
						<p className={"center"}>{MAX_EMAILS_ERROR}</p>
					</FormParagraph>
				)}
			</div>
		</div>
	</>
 );




export default FilingParty;
